import React, { Component } from 'react'
import { Card, Button, Form, Row, Image, Col, Collapse } from 'react-bootstrap';
import { FaPencilAlt, FaRegWindowClose, FaEdit, FaPlus, FaTrash, FaMinus } from 'react-icons/fa';
import { isNullOrUndefined } from 'util';
import { connect } from 'react-redux';
import { pollOperations, candidateSelectors } from './state';
import { Image as NativeImage } from 'react-native';
import { bindActionCreators } from 'redux';
import { MODE_ADD, MODE_VIEW, MODE_EDIT, SUCCESS, DATE_TIME_FORMAT, NOTIF_SUCCESS, NOTIF_ERROR, NO, SECONDARY, YES, DANGER, EMPTY_STRING, CANDIDATE_IMAGE, SUCCESS_BUTTON,
    CANDIDATE_DETAILS,POLL_DEFAULT_IMAGE,CANCEL, SAVE, MAXNUMBER_OF_CHOICES, CHOICES } from '../../../utils/constants';
import { SideNotification, isValidImageType, profileImageStyle } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, SAVE_CHANGES, MSG_CONFIRM_CHANGES, DELETE_POLLCHOICE, DELETE_MESSAGE, DELETE_POLLSELECTION,RECOMMENENDED_SIZE,CHOICE_EMPTY, CANDIDATE_IMAGE_REQUIRED, MSG_INVALID_IMAGE_TYPE } from '../../../utils/messages';
import ModalTemplate from './../../components/ModalTemplate'
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import { EditorState, ContentState } from 'draft-js';
import ConfirmationModal from '../../components/ConfirmationModal';
import htmlToDraft from 'html-to-draftjs';
import moment from 'moment';
import debounce from 'lodash.debounce';

class PollSelectionElection extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentChoiceList: null,
            activeSelection: null,
            activeChoice: null,
            selectionList: [],
            choiceList: [],
            pollDetails: props.pollDetails,
            emptyFlag: false,
            currentSelection: props.selections,
            openModal: false,
            imageFile: null,
            editorState: EditorState.createEmpty(),
            mode: props.mode,
            initialCandidateDetails: null,
            selectionId: 0,
            showSaveModal: false,
            pollSelectionChoiceDetails: [],
            imageHash: Date.now(),
            choiceId: 0,
            imageError: false,
            activeChoiceId: 0,
            activeSelectionId: 0,
            showDeleteChoiceModal: false,
            showDeleteSelectionModal: false,
            imageFileUrl: null,
            showCollapse: true
        }
        //Required to make submission possible on external button
        this.candidateForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.deleteChoice = debounce(this.deleteChoice.bind(this), 500);
        this.deleteSelection = debounce(this.deleteSelection.bind(this), 500); 
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            selectionList: newProps.selections,
            pollDetails: newProps.pollDetails,
            currentSelection: newProps.selections,
            mode: newProps.mode
        })
    }

    openModal = () => {
        this.setState({
            openModal: true,
            mode: MODE_ADD
        })
    }

    closeModal = () => {
        this.setState({
            openModal: false,
            initialCandidateDetails: null,
            editorState: EditorState.createEmpty(),
            imageFile: null,
            choiceId: 0,
            mode: MODE_EDIT
        })
    }

    isViewMode = () => {
        return MODE_VIEW === this.state.mode;
    }



    uploadImageContainer = () => {
        return (
            <React.Fragment>
                <center><label><b className={this.isViewMode() ? EMPTY_STRING : "required-input"}>{CANDIDATE_IMAGE}</b></label><br /></center>
                <Col className="flex-align">
                    <NativeImage
                        source={{ uri: (isNullOrUndefined(this.state.imageFile) ? `${REST_SERVICE_URL_ROOT}/poll/image/choice/${this.state.choiceId}?${this.state.imageHash}` : this.state.imageFileUrl) }}
                        style={profileImageStyle}
                        resizeMode={(MODE_ADD === this.state.mode && isNullOrUndefined(this.state.imageFile)) ? "contain" : "cover"}
                    />
                </Col>
                <br />
                <div className="recommended-size">
                    <p className="recommended-text">
                        {RECOMMENENDED_SIZE}
                    </p>
                </div>
                {MODE_VIEW !== this.state.mode && (
                    <div className="flex-align">
                        <div>
                            {this.state.imageError && <><label className="formik-error">{CANDIDATE_IMAGE_REQUIRED}</label><br /></>}
                            <input type='file' id='photo' accept='image/*' onChange={this.handleImageFile} /><br />
                        </div>
                    </div>
                )}
            </React.Fragment>

        );
    }

    handleImageFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            this.setState({ imageFile: event.target.files[0], imageFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]) }, () => {
                MODE_ADD === this.state.mode && this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
            })
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }

        
    }


    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateEditorState = (editorState) => {
        this.setState({ editorState })
    }


    onSubmitClick = () => {

        this.form.submitForm();
        if (MODE_ADD === this.state.mode) {
            this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
        }
    }

    handleSubmit = (values) => {

        let selectionId = this.state.currentSelection.selectionId
        let newChoices = values.CandidateModel

        let params = {
            "selectionId": selectionId,
            "choiceLabel": newChoices.choiceLabel,
            "choiceDescription": newChoices.choiceDescription
        }

        if (isNullOrUndefined(this.state.imageFile) && MODE_ADD === this.state.mode) {
            this.setState({ imageError: true })
        } else {
            this.setState({ imageError: false, pollSelectionChoiceDetails: params }, () => this.toggleSave());
        }
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    deleteChoiceToggle = (id) => {
        this.setState({
            activeChoiceId: id,
            showDeleteChoiceModal: !this.state.showDeleteChoiceModal
        })
    }

    deleteChoice = () => {
        let pollId = this.state.pollDetails.pollId
        this.props.deletePollSelectionChoice(pollId, this.state.activeChoiceId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);

                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.deleteChoiceToggle(this.state.activeChoiceId);
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    deleteSelectionToggle = (id) => {
        this.setState({
            activeSelectionId: id,
            showDeleteSelectionModal: !this.state.showDeleteSelectionModal
        })
    }

    deleteSelection = () => {
        let pollId = this.state.pollDetails.pollId
        this.props.deletePollSelection(pollId, this.state.activeSelectionId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }

                this.deleteSelectionToggle(this.state.activeSelectionId);

            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    renderButtons = () => {
        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.closeModal },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.closeModal },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                ]
            }
            default: {
                return []
            }
        }
    }

    editChoice = (choiceSelectedId) => {

        let tempChoiceList = this.state.currentSelection.choiceList
        let currentChoice = tempChoiceList.filter((data) => data.choiceId === choiceSelectedId)

        let contentState = null;
        let blocksFromHtml = htmlToDraft(currentChoice[0].choiceDescription);
        let { contentBlocks, entityMap } = blocksFromHtml;
        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

        this.setState({
            initialCandidateDetails: { CandidateModel: currentChoice[0] },
            openModal: true,
            choiceId: choiceSelectedId,
            editorState: EditorState.createWithContent(contentState),
            imageError: false,
            mode: MODE_EDIT
        })

    }

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    saveChanges = () => {
        let values = this.state.pollSelectionChoiceDetails;
        let pollId = this.state.pollDetails.pollId;
        values.choiceId = this.state.choiceId
        if (MODE_EDIT === this.state.mode) {
            this.props.updatePollSelectionChoice(values, pollId, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({
                            mode: MODE_VIEW,
                            showSaveModal: false,
                            initialCandidateDetails: null,
                            openModal: false,
                            imageFile: null,
                            imageFileUrl: null,
                            choiceId: 0,
                            editorState: EditorState.createEmpty()
                        })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertPollSelectionChoice(values, pollId, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.setState({
                            pollSelectionChoiceDetails: [],
                            imageFile: null,
                            showSaveModal: false,
                            openModal: false,
                            choiceId: 0,
                            imageFileUrl: null,
                            editorState: EditorState.createEmpty()

                        })
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    toggle = () => {
        this.setState({
            showCollapse: !this.state.showCollapse
        })
    }


    render() {
        let selection = this.state.currentSelection
        let pollDetails = this.state.pollDetails
        let now = moment().format(DATE_TIME_FORMAT)
        let user = this.props.isAuthenticated
        let donePoll = false
        let onGoingPoll = false
        if (moment(now).isAfter(pollDetails.pollEndDate)) {
            donePoll = true
        }
        else if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && 1 === user.credentials.accessRights) {
            onGoingPoll = true
        }
        return (
            <div>
                <Card style={{ width: '50%', padding: '0px', margin: '30px auto auto auto' }}>
                    <Card.Header className="text-white" style={{ backgroundColor: 'var(--primaryColor)' }}>{selection.selectionTitle}{this.state.showCollapse ? <FaMinus className="toggle-button" onClick={() => this.toggle()} /> : <FaPlus className="toggle-button" onClick={() => this.toggle()} />}</Card.Header>
                    <Collapse in={this.state.showCollapse}>
                        <Card.Body>
                            <span style={{ fontSize: '14px' }}>{MAXNUMBER_OF_CHOICES}</span> <br />
                            <b style={{ marginLeft: '30px' }}>{selection.numChoices}</b> <br />
                            <span style={{ marginTop: '30px' }}>{CHOICES}</span> <br />
                            <Button variant="light" style={{ borderColor: '#000000', visibility: onGoingPoll && 'hidden' }} disabled={MODE_EDIT !== this.state.mode || onGoingPoll || donePoll} onClick={() => this.openModal()}><FaPlus /> Add</Button>

                            {!isNullOrUndefined(selection.choiceList) && selection.choiceList.map((data, i) => {
                                let condition = (!isNullOrUndefined(this.state.activeChoice) && i !== this.state.activeChoice) || (MODE_EDIT !== this.state.mode || onGoingPoll)
                                return (
                                    <div key={i} style={{ marginTop: '10px' }}>
                                        <Row key={i} style={{ marginLeft: '0px' }}>
                                            <Image
                                                roundedCircle
                                                src={`${REST_SERVICE_URL_ROOT}/poll/image/choice/${data.choiceId}?${new Date()}`}
                                                className="candidate-image"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = POLL_DEFAULT_IMAGE
                                                }}
                                            />
                                            <Form.Control value={data.choiceLabel} data-item={i} name="choiceLabel" disabled={this.state.activeChoice !== i} style={{ width: '30%' }} className="input-candidate" placeholder={"Enter choice"}></Form.Control>
                                            <div className="action-buttons">
                                                <Button onClick={() => this.editChoice(data.choiceId)} disabled={condition} variant="light" style={{ borderColor: '#000000', marginLeft: '10px', visibility: onGoingPoll && 'hidden' }}>
                                                    <FaEdit />
                                                </Button>
                                                <Button onClick={() => this.deleteChoiceToggle(data.choiceId)} disabled={condition} variant="light" style={{ borderColor: '#000000', marginLeft: '10px', visibility: onGoingPoll && 'hidden' }}>
                                                    <FaTrash />
                                                </Button>
                                            </div>
                                        </Row>
                                        {(data.emptyFlag) &&
                                            (<p className="choice-error">{CHOICE_EMPTY}</p>)}
                                    </div>
                                )
                            })}
                        </Card.Body>
                    </Collapse>
                    <Collapse in={this.state.showCollapse}>
                        <Card.Footer>
                            <div style={{ float: 'right' }}>
                                <Button onClick={() => this.deleteSelectionToggle(selection.selectionId)} disabled={MODE_EDIT !== this.state.mode} variant="light" style={{ borderColor: '#000000', marginRight: '10px', visibility: onGoingPoll && 'hidden' }}>Delete</Button>
                            </div>
                        </Card.Footer>
                    </Collapse>
                </Card>

                <ModalTemplate
                    openModal={this.state.openModal}
                    closeModal={() => this.closeModal()}
                    title={CANDIDATE_DETAILS}
                    uploadImageContainer={this.uploadImageContainer}
                    form={this.props.candidateForm}
                    bindSubmitFormik={this.bindSubmitFormik}
                    editorState={this.state.editorState}
                    updateEditorState={this.updateEditorState}
                    renderButtons={this.renderButtons()}
                    updateFormRef={this.updateFormRef}
                    handleSubmit={this.handleSubmit}
                    initialValues={this.state.initialCandidateDetails}
                    validate={candidateSelectors.validateForm}
                    editMode={MODE_ADD !== this.state.mode}
                    readOnly={MODE_VIEW === this.state.mode}
                />

                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteChoiceModal}
                    toggleModal={this.deleteChoiceToggle}
                    title={DELETE_POLLCHOICE}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.deleteChoiceToggle, variant: SECONDARY },
                        { label: YES, onClick: this.deleteChoice, variant: DANGER }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteSelectionModal}
                    toggleModal={this.deleteSelectionToggle}
                    title={DELETE_POLLSELECTION}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.deleteSelectionToggle, variant: SECONDARY },
                        { label: YES, onClick: this.deleteSelection, variant: DANGER }
                    ]}
                />
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        pollForm: state.polls.pollForm,
        selectInput: state.polls.selectInput,
        poll: state.polls.poll,
        candidateForm: state.polls.candidateForm,
        isAuthenticated: state.auth
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertPollSelectionChoice: pollOperations.insertPollSelectionChoice,
        updatePollSelectionChoice: pollOperations.updatePollSelectionChoice,
        deletePollSelection: pollOperations.deletePollSelection,
        deletePollSelectionChoice: pollOperations.deletePollSelectionChoice
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(PollSelectionElection);